import { AppConfig } from 'config/app';

export class RouteTo {
	/**
	 * Generates URL to public page of Event
	 *
	 * @param eventId
	 */
	public static eventPublic(eventId: string): string {
		return '/event/detail/' + eventId;
	}

	/**
	 * Generates URL to public page of Event
	 *
	 * @param ticketCode
	 */
	public static ticketPublic(ticketCode: string): string {
		return '/ticket/' + ticketCode;
	}

	/**
	 * Generates URL to public page of Event
	 *
	 * @param ticketCode
	 */
	public static ticketPrivate(ticketCode: string): string {
		return '/event/:eventId/ticket/' + ticketCode;
	}

	/**
	 * Stripe Connect Setup
	 *
	 * @param userId
	 */
	public static paymentSetup(userId: string): string {
		return 'https://connect.stripe.com/express/oauth/authorize?redirect_uri=' + AppConfig.hostUrl + '/paymentCallBack&client_id=ca_FEjtPwEfbDFEiwLSnMzq9sGftqkbUaqn&state=' + userId;
	}

	// Event URL Redirection
	public static eventLinkRedirect(code: string): string {
		return '/event-' + code;
	}

	// Referral URL Redirection
	public static referralLinkRedirect(code: string, index: string): string {
		return '/event-' + code + '/' + index;
	}


    /**
     * Takes printed ticket tickets to the right link
     *
     * @param ticketCode
     */
	public static printedTicketRedirect(ticketCode: string): string {
		return '/' + ticketCode;
	}

	/**
	 * Generates URL to referral link in an Event
	 *
	 * @param eventId
	 * @param promoterId
	 */
	public static referralPublic(eventId: string, promoterId: string): string {
		return '/event/detail/' + eventId + '/' + promoterId;
	}

	/**
	 * Return URL to Manage > Events
	 */
	public static manageEvents(): string {
		return '/manage/events';
	}

	/**
	 * Generates URL to Event > edit
	 *
	 * @param eventId
	 */
	public static eventEdit(eventId: string): string {
		return '/manage/events/edit/' + eventId;
	}

	/**
	 * Generates URL to Event > Manage
	 *
	 * @param eventId
	 */
	public static eventDetail(eventId: string): string {
		return '/manage/events/detail/' + eventId;
	}

	/**
	 * Returns URL to Manage > Events > Create
	 */
	public static eventCreate(): string {
		return '/manage/events-create';
	}

	/**
	 * Generate URL to Event Check-In
	 *
	 * @param eventId
	 */
	public static eventCheckIn(eventId: string): string {
		return '/manage/events/checkin/' + eventId;
	}

	/**
	 * Generates URL to Event > Delete
	 *
	 * @param eventId
	 */
	public static eventDelete(eventId: string): string {
		return '/manage/events/delete/' + eventId;
	}

	/**
	 * Generates URL to Event > Activate ticket(s)
	 *
	 * @param eventId
	 */

	public static eventActivatePhysical(eventId: string): string {
		return '/manage/activate/physical/' + eventId;
	}

	public static eventActivateDigital(eventId: string): string {
		return '/manage/activate/digital/' + eventId;
	}

	public static oneTimeLink(email: string, password: string): string {
		return '/setup/' + email + '/' + password
	}

	public static login(): string {
		return '/login';
	}

	public static moreEventsBy(userId: string, hostname: string): string {
		return '/host/' + userId + '/' + hostname;
	}
}



// WEBPACK FOOTER //
// ./src/lib/utils/routing.ts